import Axios from "axios";
import {UPDATE_DEVIS_STATE} from "../actions/chatCase/devis";
import {getApiBaseUrl} from "../utils/baseUrl";
import {getDocuments} from "../actions/chatCase/document";

// On définit par défaut un TimeOut Axios à 10 seconde au bout desquelles un code erreur "ECONNABORTED" est envoyé (code que l'on peut .catch dans une promesse)
// et qui permet donc de définir un message d'erreur en cas de non réponse de l'API
Axios.defaults.timeout = 1000000;

const devis = (store) => (next) => action => {
    switch (action.type) {
        case UPDATE_DEVIS_STATE : {

            const state = store.getState();
            // récupération du state du reducer modal.js
            const {modal} = state;

            const url = `${getApiBaseUrl()}/updateDevis/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "idDocument": modal.idDocument,
                "toUpdate": {
                    "state": action.state // update du state en BDD
                }
            };
            // Update du state du devis (accepté/refusé)
            Axios.post(url, payload, {withCredentials: true})
                .then(() => {
                    // Une fois updaté, on rafraîchis la liste des documents
                    store.dispatch(getDocuments());
                });


            next(action);
            break;
        }
        default:
            // eslint-disable-next-line no-mixed-spaces-and-tabs
            next(action);
    }
};

export default devis;